export default "__VITE_ASSET__Dl4L80cG__"